export default {
  common: {
    account: '账户',
    myPage: '我的主页',
    booking: '订单记录',
    logout: '退出登录',
    save: '保存',
    colon: '：',
    multiply: '×',
    next: '下一步',
    return: '返回',
    toPay: '前往付款',
    update: '更新',
    search: '搜索',
    space: ' ',
    add: '添加',
    confirm: '确认',
    cancel: '取消',
    searchPlaceholder: '搜索...',
    tilde: '~',
    showMore: '更多'
  },
  price: {
    primary: '<currency>{{currency}}</currency> <amount>{{amount}}</amount>',
    jpyWord: 'JPY',
    jpySymbol: '¥'
  },
  footer: {
    terms: '使用条款',
    cert: '旅行業登録：東京都知事登録旅行業第2-8013号（リンクティビティ株式会社）',
    copyright: '{{year}} Copyright LINKTIVITY Inc.© All Rights Reserved.'
  },
  validation: {
    required: '{{field}}为必填项',
    invalid: '请输入有效的{{field}}',
    password: '请输入至少8个字符，包含大写字母、小写字母、符号和数字',
    imageType: '请选择图片文件',
    fileSize: '请选择小于{{size}}MB的文件',
    range: '请输入{{min}}到{{max}}之间的值',
    requiredSelect: '请选择{{field}}选项',
    emailNotMatch: '邮箱地址不一致',
    emailAlreadyRegistered: '该邮箱地址已注册，请先通过登录按钮进行登录。'
  },
  firebase: {
    'auth/wrong-password': '帐户名或密码有误。',
    'auth/user-not-found': '帐户名或密码有误。',
    'auth/email-already-in-use': '该邮箱已被注册。',
    'auth/too-many-requests': '登录失败超过有限次数，烦请重设密码或稍后再试。'
  },
  apiErrors: {
    baseError: '检测到有错误发生。',
    clientError: 'API 请求存在错误。',
    serverError: '服务器无法完成该请求。',
    connectionError: '与服务器的连接失败。请检查网络设置后重试。',
    requestError: 'API 请求存在错误。',
    ARSError: {
      AFFILIATE_ID_REQUIRED:
        '操作失败，请回到原会员专属首页后再次进入商品页重新尝试。',
      BOOKING_NOT_ENOUGH_ALLOTMENT:
        '非常抱歉，由于所选日期/时间之库存数量不足，烦请选择其他日期/时间预订。',
      BOOKING_NO_AVAILABILITY:
        '非常抱歉，由于所选日期/时间之库存数量不足，烦请选择其他日期/时间预订。',
      PERMISSION_DENIED: '非常抱歉，您无权访问该资源。',
      NOT_FOUND: '未找到资源。',
      BOOKING_ALREADY_ISSUED: '恕无法取消已兑换或使用的订单。',
      BOOKING_RESERVATION_OVERLIMIT: '预订数量已超出上限。'
    }
  },
  login: {
    title: '登录／注册',
    caption: '请选择登录、注册会员的方式。',
    appleLogin: 'Apple',
    googleLogin: 'Google',
    email: '邮箱地址',
    emailConfirm: '邮箱地址（确认）',
    password: '密码',
    button: '登录',
    forgotPassword: '忘记密码？',
    newAccount: '注册',
    signInAgree:
      '※可使用第三方帐户轻松登录、注册会员。\n ※当您使用邮箱或第三方帐户登录时，将视同您已同意相关 <TermsLink>{{terms}}</TermsLink> 与 <PrivacyLink>{{privacy}}</PrivacyLink> 。'
  },
  password: {
    changePassword: '更改密码',
    resetPassword: '重设密码',
    sendResetEmail: '发送密码重设邮件',
    sendResetEmailSuccess:
      '已将密码重设链接发送至{{email}}，烦请确认并重新设定密码。',
    oldPassword: '原密码',
    newPassword: '新密码',
    changePasswordSuccess: '密码已成功变更。'
  },
  date: {
    sunday: '星期日',
    monday: '星期一',
    tuesday: '星期二',
    wednesday: '星期三',
    thursday: '星期四',
    friday: '星期五',
    saturday: '星期六'
  },
  profile: {
    title: '个人信息',
    firstName: '名（请输入半角英语）',
    lastName: '姓（请输入半角英语）',
    email: '邮箱',
    confirmEmail: '邮箱（确认）',
    password: '密码',
    gender: '性别',
    birthday: '出生日期',
    country: '国家和地区',
    prefecture: '省份',
    genderOptions: {
      male: '男性',
      female: '女性',
      other: '其他'
    },
    updateProfileSuccess: '个人信息更新成功',
    updateProfileFailed: '个人信息更新失败, 请稍后重试'
  },
  weeks: {
    sun: '日',
    mon: '月',
    tue: '火',
    wed: '水',
    thu: '木',
    fri: '金',
    sat: '土'
  },
  empty: {
    message: '没有内容'
  }
};
